<template>
    <NavBar />

    <h3 id="pageHeader">This is the Planet Page</h3>

    <div class="panel">


    </div>
</template>
  
<script>
export default {
    name: "HomePage",
    components: {
    },
};


</script>
  
<style scoped></style>